import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import { useLocation, useNavigate } from "react-router-dom";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import { TkRouteContext } from "../../context/tkRouteContext";
import { IAPI_STA025_Response } from "../../type/apiType";
import { httpAPI_FAC019, httpAPI_STA025, httpAPI_STA032 } from "./api/request";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import { searchFormList, searchFormSchema } from "./parts";
import StaffListTable from "./components/components";
import type { StaffList } from "../../type/apiType/IAPI_STA025";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import dayjs from "dayjs";
import { ConfirmStatus } from "../../assets/data/Constants";
import _ from "lodash";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * SCRC060112 従業状況更新
 * @return SCRC060112 従業状況更新
 */
const SCRC060112 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [facilityList, setFacilityList] = useState<any>();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state: stateRouter, setState: setStateRouter } =
    useContext(TkRouteContext);
  const contractorNo =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
      ? businessState.common?.contractorNo
      : state.authInfo?.contractorNo;
  const [selectFacilityNo, setSelectFacilityNo] = useState("");
  const jobTypeName = String(
    businessState.common?.businessType?.toLowerCase().replace("-", "_")
  );
  const job_xx =
    jobTypeName &&
    (businessState as Record<string, any>)[
      jobTypeName === "job_31" ? "job_32" : jobTypeName
    ];

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [stateSearchList, setStateSearchList] = useState(searchFormList);
  const [openWarning, setOpenWarning] = useState(false);

  const currentStaffNoRef = useRef("");
  const currentStaffNo = currentStaffNoRef.current;
  const setCurrentStaffNo = (value: string) => {
    currentStaffNoRef.current = value;
  };

  const resRef = useRef<IAPI_STA025_Response>({});
  const res = resRef.current;
  const setRes = (data: IAPI_STA025_Response) => {
    resRef.current = data;
  };

  const staffListRef = useRef<StaffList[]>([]);
  const staffList = staffListRef.current;
  const setStaffList = (data: StaffList[]) => {
    staffListRef.current = data;
  };

  const staffNameRef = useRef("");
  const staffName = staffNameRef.current;
  const setStaffName = (value: string) => {
    staffNameRef.current = value;
  };

  const changeRef = useRef(false);
  const change = changeRef.current;
  const setChange = (value: boolean) => {
    changeRef.current = value;
  };
  const [dateErrorFlg, setDateErrorFlg] = useState(false);

  // 従業状況更新参照API
  const handleInit = async () => {
    try {
      const res = await httpAPI_STA025({
        contractorNo,
        facilityNo: location.state?.facilityNo ?? job_xx?.facilityNo,
        staffNo: location.state?.staffNo ?? job_xx?.staffNo,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        setChange(true);

        setFacilityList([
          {
            value: location.state?.facilityNo ?? job_xx?.facilityNo,
            label:
              (location.state?.facilityNo ?? job_xx?.facilityNo ?? "") +
              ":" +
              (location.state?.facilityName ?? job_xx?.facilityName ?? ""),
          },
        ]);

        setSelectFacilityNo(location.state?.facilityNo ?? job_xx?.facilityNo);

        location.state?.facilityNo &&
          setBusinessState({
            ...businessState,
            [jobTypeName]: {
              ...job_xx,
              facilityNo: location.state?.facilityNo,
              facilityName: location.state?.facilityName,
            },
          });

        setRes(res);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // プルダウン用有効施設一覧参照APIを呼び出す
  const handleInit2 = async () => {
    try {
      const res = await httpAPI_FAC019({
        contractorNo,
        businessType: businessState.common?.businessType,
      });

      if (res.resultCd === "I0000") {
        let facilityList: any = res.facilityList?.map((item: any) => ({
          value: item.facilityNo,
          label: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
        }));
        setFacilityList(facilityList ?? []);

        if (businessState.employeeStatusUpdate?.selectedFacilityNo) {
          setSelectFacilityNo(
            businessState.employeeStatusUpdate?.selectedFacilityNo
          );
          setStaffName(
            businessState.employeeStatusUpdate?.selectedStaffName ?? ""
          );
          let resArr = stateSearchList;
          resArr.find((item) => item.keyword === "name")!.wantToSetValue =
            businessState.employeeStatusUpdate?.selectedStaffName;
          setStateSearchList([...resArr]);
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    if (location.state?.facilityNo || job_xx?.facilityNo) {
      handleInit();
    } else {
      handleInit2();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeFacility = async (
    value: any,
    type: "change" | "search"
  ) => {
    if (type === "change") {
      setSelectFacilityNo(value);
      if (!value) return;
    }

    try {
      const res = await httpAPI_STA025({
        contractorNo,
        facilityNo: type === "change" ? value : selectFacilityNo,
        staffName: type === "search" ? value : staffName,
        staffNo: location.state?.staffNo ?? job_xx?.staffNo,
      });

      if (res.resultCd === "I0000") {
        setRes(res);
        setStaffName("");
        setBusinessState({
          ...businessState,
          employeeStatusUpdate: {
            ...businessState.employeeStatusUpdate,
            selectedStaffName: type === "search" ? value : "",
          },
        });
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setRes(res);
        setStaffName("");
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 育児休業情報登録
  const handleSure = () => {
    setBusinessState({
      ...businessState,
      employeeStatusUpdate: {
        ...businessState.employeeStatusUpdate,
        selectedFacilityNo: selectFacilityNo,
      },
    });

    navigate("/SCRC060101", { state: { staffNo: currentStaffNo } });
  };

  // 退職（予定）日チェック
  const handleRetireDateCheck = () => {
    let result = true;
    setState({
      ...state,
      errorMsgId: "",
    });
    try {
      staffList?.forEach?.((staff: any) => {
        if (!staff.retireDate) return;
        const resStaffList = res.staffList?.find(
          (item) => item.staffNo === staff.staffNo
        );
        // 更新していないときはチェックしない
        if (resStaffList?.retireDate === staff.retireDate) return;

        const retireDate = dayjs(staff.retireDate);
        const confirmStatus = state.authInfo?.confirmStatus;
        const fiscalYear = state.authInfo?.fiscalYear!;
        if (
          confirmStatus === ConfirmStatus["未確定"] ||
          confirmStatus === ConfirmStatus["確定中"]
        ) {
          // 当年度の掛金確定前 かつ 入力内容.退職（予定）日 ≦ 前々年度末（３月３１日）
          if (retireDate.isBefore(dayjs(`${fiscalYear - 1}/04/01`))) {
            setState({
              ...state,
              errorMsgId: "TKMSG_SCR0033E",
            });
            result = false;
            setOpenDialog(false);
            setOpenDialog2(false);
          }
        }
      });
    } catch (error) {
      result = false;
    }
    return result;
  };

  //登録ボタン押下
  const handleClickSubmit = () => {
    if (res.staffList && staffListRef.current) {
      //業務チェック
      const today = new Date();
      const nextYearDate = new Date(today.setFullYear(today.getFullYear() + 1));
      const updatedChangeRetireDateList = staffListRef.current.filter(
        (item, index) => {
          return item.retireDate !== res?.staffList![index].retireDate;
        }
      );
      const result = updatedChangeRetireDateList?.some((item) => {
        const retireDate = new Date(item?.retireDate!); // retireDateをDateオブジェクトに変換
        nextYearDate.setHours(0, 0, 0, 0);
        retireDate.setHours(0, 0, 0, 0);
        return retireDate >= nextYearDate; // 基準日（newDate）と比較
      });
      if (result) {
        //入出力項目.退職（予定）日 ≧ システム日付 + 1年
        setOpenWarning(true);
      } else {
        setOpenDialog2(true);
      }
    } else {
      setOpenDialog2(true);
    }
  };
  // 登録
  const handleSubmit = async () => {
    if (!handleRetireDateCheck()) return;

    // 日々更新法人職員系TBLの更新API 呼び出し
    try {
      let reqStaffList: any =
        _.cloneDeep(staffList)?.map((item: any) => {
          delete item.createUser;
          delete item.staffNameKanji;
          delete item.birthday;
          delete item.loackState;
          item.transferReason = null;

          return item;
        }) ?? [];

      const res = await httpAPI_STA032({
        contractorNo,
        staffList: reqStaffList,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setOpenDialog2(false);

        let routerList = stateRouter.routerList || [];
        if (routerList.length > 1) {
          setStateRouter({
            ...stateRouter,
            routerList: [...routerList.slice(0, routerList.length - 1)],
          });
          navigate(`${routerList[routerList.length - 2].href}`);
        } else {
          setStateRouter({});
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setOpenDialog2(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };
  const handleOpenSubmitModal = () => {
    setOpenWarning(false);
    setOpenDialog2(true);
  };

  useEffect(() => {
    if (!stateRouter.routerList) {
      switch (state.authInfo?.userType) {
        case authorityUserType.userTypeNumber.KEIYAKUSYA:
          navigate("/SCRC020001");
          break;
        case authorityUserType.userTypeNumber.DAIKOSHA:
          navigate("/SCRD310001");
          break;
        default:
          navigate("/error");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateRouter]);

  return (
    <Box className="SCRC060112" data-testid="SCRC060112PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC060112_01}</TkInfoManual>

      <TkFakeTableLine
        title="施設選択"
        type="selectForm"
        disabled={change}
        setDefaultValue={selectFacilityNo}
        selectPropsList={facilityList}
        onChange={(e: any) => handleChangeFacility(e.target.value, "change")}
      />

      {selectFacilityNo && (
        <>
          <Box className="info">
            <Box>
              １）「ならない月」を登録してください。
              <TkHelpIcon
                helpMessage={
                  <>
                    表示されている年度のならない月を登録してください。
                    <br />
                    ならない月とは、業務に従事した日数（従事したとみなす日を含む）が１０日を超えない月です。
                    <br />
                    詳しくは
                    <a
                      href={`${
                        process.env.PUBLIC_URL ?? ""
                      }/assets/pdf/≪別紙≫「なる月」「ならない月」について.pdf`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      こちら
                    </a>
                    をご確認ください。
                  </>
                }
              />
            </Box>
            <Box>
              ２）育児休業をとった職員、育児休業の終了日を変更する職員がいる場合に、登録してください。
            </Box>
            <Box>
              ３）退職予定の職員がいる場合に退職予定日を登録してください。
            </Box>
          </Box>

          <Box className="table">
            <TkSearchForm
              listData={stateSearchList}
              ruleSchema={searchFormSchema}
              onSearch={(e: any) => handleChangeFacility(e.name, "search")}
            />
            <StaffListTable
              res={res}
              onClick={(item: any) => {
                setCurrentStaffNo(item.staffNo);
                setOpenDialog(true);
              }}
              onChange={setStaffList}
              setDateErrorFlg={setDateErrorFlg}
            />
          </Box>
        </>
      )}

      <Box className="btns">
        <TkBackButton />
        {selectFacilityNo && (
          <TkButton
            onClick={handleClickSubmit}
            disabled={!res.staffList?.length || dateErrorFlg}
          >
            登録
          </TkButton>
        )}
      </Box>

      <TkMessageDialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setCurrentStaffNo("");
        }}
        onCancel={() => {
          setOpenDialog(false);
          setCurrentStaffNo("");
        }}
        onOky={handleSure}
        title="確認（画面遷移します）"
        contextText="　登録せず「育児休業情報登録」画面に遷移した場合は、従業状況更新画面で入力した内容は破棄されます。"
        okText="はい"
        cancelText="いいえ"
      />

      <TkMessageDialog
        open={openDialog2}
        onClose={() => setOpenDialog2(false)}
        onCancel={() => setOpenDialog2(false)}
        onOky={handleSubmit}
        title="確認（情報を登録します）"
        contextText="　入力した内容で登録を行いますが、問題ないでしょうか。"
        okText="はい"
        cancelText="いいえ"
      />
      <TkMessageDialog
        open={openWarning}
        onOky={handleOpenSubmitModal}
        onCancel={() => setOpenWarning(false)}
        onClose={() => setOpenWarning(false)}
        title="警告"
        contextText={TkPropertyMessageGet("TKMSG_SCR0030W")}
        okText="確認"
        cancelText="戻る"
      />
    </Box>
  );
};

export default SCRC060112;
